//! student image

import student0 from '../image/students/imgStudent0.webp'
import student1 from '../image/students/imgStudent1.webp'
import student2 from '../image/students/imgStudent2.webp'
import student3 from '../image/students/imgStudent3.webp'
import student4 from '../image/students/imgStudent4.webp'
import student5 from '../image/students/imgStudent5.webp'
import student6 from '../image/students/imgStudent6.webp'
import student7 from '../image/students/imgStudent7.webp'
import student8 from '../image/students/imgStudent8.webp'
import student9 from '../image/students/imgStudent9.webp'
import student10 from '../image/students/imgStudent10.webp'
import student11 from '../image/students/imgStudent11.webp'
import student12 from '../image/students/imgStudent12.webp'
import student13 from '../image/students/imgStudent13.webp'
import student14 from '../image/students/imgStudent14.webp'
import student15 from '../image/students/imgStudent15.webp'
import student16 from '../image/students/imgStudent16.webp'
import student17 from '../image/students/imgStudent17.webp'
import student18 from '../image/students/imgStudent18.webp'
import student19 from '../image/students/imgStudent19.webp'
import student20 from '../image/students/imgStudent20.webp'
import student21 from '../image/students/imgStudent21.webp'
import student22 from '../image/students/imgStudent22.webp'
import student23 from '../image/students/imgStudent23.webp'
import student24 from '../image/students/imgStudent24.webp'
import student25 from '../image/students/imgStudent25.webp'
import student26 from '../image/students/imgStudent26.webp'
import student27 from '../image/students/imgStudent27.webp'
import student28 from '../image/students/imgStudent28.webp'
import student29 from '../image/students/imgStudent29.webp'
import student30 from '../image/students/imgStudent30.webp'
import student31 from '../image/students/imgStudent31.webp'
import student32 from '../image/students/imgStudent32.webp'
import student33 from '../image/students/imgStudent33.webp'
import student34 from '../image/students/imgStudent34.webp'
import student35 from '../image/students/imgStudent35.webp'
import student36 from '../image/students/imgStudent36.webp'
import student37 from '../image/students/imgStudent37.webp'
import student38 from '../image/students/imgStudent38.webp'
import student39 from '../image/students/imgStudent39.webp'
import student40 from '../image/students/imgStudent40.webp'
import student41 from '../image/students/imgStudent41.webp'
import student42 from '../image/students/imgStudent42.webp'
import student43 from '../image/students/imgStudent43.webp'
import student44 from '../image/students/imgStudent44.webp'
import student45 from '../image/students/imgStudent45.webp'
import student46 from '../image/students/imgStudent46.webp'
import student47 from '../image/students/imgStudent47.webp'
import student48 from '../image/students/imgStudent48.webp'
import student49 from '../image/students/imgStudent49.webp'
import student50 from '../image/students/imgStudent50.webp'
import student51 from '../image/students/imgStudent51.webp'
// import student52 from '../image/students/imgStudent52.webp no pull'
import student53 from '../image/students/imgStudent53.webp'
import student54 from '../image/students/imgStudent54.webp'
import student55 from '../image/students/imgStudent55.webp'
import student56 from '../image/students/imgStudent56.webp'
// import student59 from '../image/students/imgStudent59.webp no pull'
import student60 from '../image/students/imgStudent60.webp'
// import student63 from '../image/students/imgStudent63.webp no pull'
import student64 from '../image/students/imgStudent64.webp'
import student65 from '../image/students/imgStudent65.webp'
import student66 from '../image/students/imgStudent66.webp'
import student67 from '../image/students/imgStudent67.webp'
import student70 from '../image/students/imgStudent70.webp'
import student71 from '../image/students/imgStudent71.webp'
import student72 from '../image/students/imgStudent72.webp'
import student74 from '../image/students/imgStudent74.webp'
import student75 from '../image/students/imgStudent75.webp'
import student76 from '../image/students/imgStudent76.webp'
// import student77 from '../image/students/imgStudent77.webp no pull'
import student78 from '../image/students/imgStudent78.webp'
import student81 from '../image/students/imgStudent81.webp'
// import student83 from '../image/students/imgStudent83.png no pull'
import student84 from '../image/students/imgStudent84.png'
import student85 from '../image/students/imgStudent85.png'
import student86 from '../image/students/imgStudent86.png'
import student87 from '../image/students/imgStudent87.png'
import student88 from '../image/students/imgStudent88.png'
import student89 from '../image/students/imgStudent89.png'
import student90 from '../image/students/imgStudent90.png'
import student91 from '../image/students/imgStudent91.png'
import student92 from '../image/students/imgStudent92.png'
import student93 from '../image/students/imgStudent93.png'
import student94 from '../image/students/imgStudent94.png'

//! limited students

import student57 from '../image/limitedStudents/imgStudent57.webp'
import student58 from '../image/limitedStudents/imgStudent58.webp'
import student61 from '../image/limitedStudents/imgStudent61.webp'
import student62 from '../image/limitedStudents/imgStudent62.webp'
import student68 from '../image/limitedStudents/imgStudent68.webp'
import student69 from '../image/limitedStudents/imgStudent69.webp'
import student73 from '../image/limitedStudents/imgStudent73.png'
import student79 from '../image/limitedStudents/imgStudent79.webp'
import student80 from '../image/limitedStudents/imgStudent80.webp'
import student82 from '../image/limitedStudents/imgStudent82.png'

//! school icon

import schoolAbidosIcon from '../image/icon/schoolIcon/schoolAbidosIcon.svg'
import schoolAriusIcon from '../image/icon/schoolIcon/schoolAriusIcon.svg'
import schoolGehennaIcon from '../image/icon/schoolIcon/schoolGehennaIcon.svg'
import schoolHyakkiyakoIcon from '../image/icon/schoolIcon/schoolHyakkiyakoIcon.svg'
import schoolMillenniumIcon from '../image/icon/schoolIcon/schoolMillenniumIcon.svg'
import schoolRedWinterIcon from '../image/icon/schoolIcon/schoolRedWinterIcon.svg'
import schoolShanhaijingIcon from '../image/icon/schoolIcon/schoolShanhaijingIcon.svg'
import schoolSRTIcon from '../image/icon/schoolIcon/schoolSRTIcon.svg'
import schoolTrinityIcon from '../image/icon/schoolIcon/schoolTrinityIcon.svg'
import schoolValkyrieIcon from '../image/icon/schoolIcon/schoolValkyrieIcon.svg'
import schoolETCIcon from '../image/icon/schoolIcon/schoolETCIcon.svg'

//! ultra rare

export const importStudentsUltraRare = {
    standartPull: {
        eventInfo: {
            name: `Standart Pull`,
            value: 'standartPull'
        },

        students: [
            {
                id: 0,
                name: 'Aru',
                imgStudent: student0,
                school: 'Gehenna',
                schoolIcon: schoolGehennaIcon,
                attackType: 'Explosive',
            },
        
            {
                id: 1,
                name: 'Eimi',
                imgStudent: student1,
                school: 'Millennium',
                schoolIcon: schoolMillenniumIcon,
                attackType: 'Explosive',
            },
            
            {
                id: 2,
                name: 'Haruna',
                imgStudent: student2,
                school: 'Gehenna',
                schoolIcon: schoolGehennaIcon,
                attackType: 'Mystic',
            },
        
            {
                id: 3,
                name: 'Hifumi',
                imgStudent: student3,
                school: 'Trinity',
                schoolIcon: schoolTrinityIcon,
                attackType: 'Piercing',
            },
        
            {
                id: 4,
                name: 'Hina',
                imgStudent: student4,
                school: 'Gehenna',
                schoolIcon: schoolGehennaIcon,
                attackType: 'Explosive',
            },
        
            {
                id: 5,
                name: 'Hoshino',
                imgStudent: student5,
                school: 'Millennium',
                schoolIcon: schoolMillenniumIcon,
                attackType: 'Piercing',
            },
        
            {
                id: 6,
                name: 'Iori',
                imgStudent: student6,
                school: 'Gehenna',
                schoolIcon: schoolGehennaIcon,
                attackType: 'Piercing',
            },
        
            {
                id: 7,
                name: 'Maki',
                imgStudent: student7,
                school: 'Millennium',
                schoolIcon: schoolMillenniumIcon,
                attackType: 'Piercing',
            },
        
            {
                id: 8,
                name: 'Neru',
                imgStudent: student8,
                school: 'Millennium',
                schoolIcon: schoolMillenniumIcon,
                attackType: 'Piercing',
            },
        
            {
                id: 9,
                name: 'Izumi',
                imgStudent: student9,
                school: 'Gehenna',
                schoolIcon: schoolGehennaIcon,
                attackType: 'Explosive',
            },
        
            {
                id: 10,
                name: 'Shiroko',
                imgStudent: student10,
                school: 'Abidos',
                schoolIcon: schoolAbidosIcon,
                attackType: 'Explosive',
            },
        
            {
                id: 11,
                name: 'Shun',
                imgStudent: student11,
                school: 'Shanhaijing',
                schoolIcon: schoolShanhaijingIcon,
                attackType: 'Explosive',
            },
        
            {
                id: 12,
                name: 'Sumire',
                imgStudent: student12,
                school: 'Millennium',
                schoolIcon: schoolMillenniumIcon,
                attackType: 'Piercing',
            },
        
            {
                id: 13,
                name: 'Tsurugi',
                imgStudent: student13,
                school: 'Trinity',
                schoolIcon: schoolTrinityIcon,
                attackType: 'Piercing',
            },
        
            {
                id: 30,
                name: 'Hibiki',
                imgStudent: student30,
                school: 'Millennium',
                schoolIcon: schoolMillenniumIcon,
                attackType: 'Explosive',
            },
        
            {
                id: 31,
                name: 'Karin',
                imgStudent: student31,
                school: 'Millennium',
                schoolIcon: schoolMillenniumIcon,
                attackType: 'Piercing',
            },
        
            {
                id: 32,
                name: 'Saya',
                imgStudent: student32,
                school: 'Shanhaijing',
                schoolIcon: schoolShanhaijingIcon,
                attackType: 'Explosive',
            },
        
            {
                id: 45,
                name: 'Mashiro',
                imgStudent: student45,
                school: 'Trinity',
                schoolIcon: schoolTrinityIcon,
                attackType: 'Explosive',
            },
        
            {
                id: 46,
                name: 'Izuna',
                imgStudent: student46,
                school: 'Hyakkiyako',
                schoolIcon: schoolHyakkiyakoIcon,
                attackType: 'Mystic',
            },
        
            {
                id: 48,
                name: 'Aris',
                imgStudent: student48,
                school: 'Millennium',
                schoolIcon: schoolMillenniumIcon,
                attackType: 'Mystic',
            },
        
            {
                id: 49,
                name: 'Midori',
                imgStudent: student49,
                school: 'Millennium',
                schoolIcon: schoolMillenniumIcon,
                attackType: 'Piercing',
            },
        
            {
                id: 51,
                name: 'Cherino',
                imgStudent: student51,
                school: 'Red Winter',
                schoolIcon: schoolRedWinterIcon,
                attackType: 'Piercing',
            },
        
            {
                id: 53,
                name: 'Yuzu',
                imgStudent: student53,
                school: 'Millennium',
                schoolIcon: schoolMillenniumIcon,
                attackType: 'Piercing',
            },
        
            {
                id: 54,
                name: 'Azusa',
                imgStudent: student54,
                school: 'Trinity',
                schoolIcon: schoolTrinityIcon,
                attackType: 'Explosive',
            },
        
            {
                id: 56,
                name: 'Koharu',
                imgStudent: student56,
                school: 'Trinity',
                schoolIcon: schoolTrinityIcon,
                attackType: 'Explosive',
            },
        
            {
                id: 60,
                name: 'S.Hifumi',
                imgStudent: student60,
                school: 'Trinity',
                schoolIcon: schoolTrinityIcon,
                attackType: 'Piercing',
            },
        
            {
                id: 64,
                name: 'C.Shiroko',
                imgStudent: student64,
                school: 'Abidos',
                schoolIcon: schoolAbidosIcon,
                attackType: 'Mystic',
            },
        
            {
                id: 65,
                name: 'S.Shun',
                imgStudent: student65,
                school: 'Shanhaijing',
                schoolIcon: schoolShanhaijingIcon,
                attackType: 'Explosive',
            },
        
            {
                id: 67,
                name: 'C.Saya',
                imgStudent: student67,
                school: 'Shanhaijing',
                schoolIcon: schoolShanhaijingIcon,
                attackType: 'Piercing',
            },
        
            {
                id: 70,
                name: 'B.Asuna',
                imgStudent: student70,
                school: 'Millennium',
                schoolIcon: schoolMillenniumIcon,
                attackType: 'Mystic',
            },
        
            {
                id: 71,
                name: 'Natsu',
                imgStudent: student71,
                school: 'Trinity',
                schoolIcon: schoolTrinityIcon,
                attackType: 'Mystic',
            },
        
            {
                id: 74,
                name: 'Ako',
                imgStudent: student74,
                school: 'Gehenna',
                schoolIcon: schoolGehennaIcon,
                attackType: 'Mystic',
            },
        
            {
                id: 75,
                name: 'H.S.Cherino',
                imgStudent: student75,
                school: 'Red Winter',
                schoolIcon: schoolRedWinterIcon,
                attackType: 'Explosive',
            },
        
            {
                id: 76,
                name: 'H.S.Chinatsu',
                imgStudent: student76,
                school: 'Gehenna',
                schoolIcon: schoolGehennaIcon,
                attackType: 'Mystic',
            },
        
            {
                id: 78,
                name: 'H.S.Nodoka',
                imgStudent: student78,
                school: 'Gehenna',
                schoolIcon: schoolGehennaIcon,
                attackType: 'Explosive',
            },
        
            {
                id: 81,
                name: 'N.Y.Serika',
                imgStudent: student81,
                school: 'Abidos',
                schoolIcon: schoolAbidosIcon,
                attackType: 'Piercing',
            },
        
            {
                id: 84,
                name: 'Sena',
                imgStudent: student84,
                school: 'Gehenna',
                schoolIcon: schoolGehennaIcon,
                attackType: 'Mystic',
            },
        
            {
                id: 85,
                name: 'Chihiro',
                imgStudent: student85,
                school: 'Millennium',
                schoolIcon: schoolMillenniumIcon,
                attackType: 'Piercing',
            },
        
            {
                id: 86,
                name: 'Mimori',
                imgStudent: student86,
                school: 'Hyakkiyako',
                schoolIcon: schoolHyakkiyakoIcon,
                attackType: 'Mystic',
            },
        
            {
                id: 87,
                name: 'Ui',
                imgStudent: student87,
                school: 'Trinity',
                schoolIcon: schoolTrinityIcon,
                attackType: 'Explosive',
            },
        
            {
                id: 88,
                name: 'Hinata',
                imgStudent: student88,
                school: 'Trinity',
                schoolIcon: schoolTrinityIcon,
                attackType: 'Mystic',
            },

            {
                id: 89,
                name: 'Marina',
                imgStudent: student89,
                school: 'Trinity',
                schoolIcon: schoolRedWinterIcon,
                attackType: 'Explosive',
            },

            {
                id: 90,
                name: 'Miyaro',
                imgStudent: student90,
                school: 'SRT',
                schoolIcon: schoolSRTIcon,
                attackType: 'Piercing',
            },

            {
                id: 91,
                name: 'Saki',
                imgStudent: student91,
                school: 'SRT',
                schoolIcon: schoolSRTIcon,
                attackType: 'Piercing',
            },

            {
                id: 92,
                name: 'Miyu',
                imgStudent: student92,
                school: 'SRT',
                schoolIcon: schoolSRTIcon,
                attackType: 'Piercing',
            },

            {
                id: 93,
                name: 'Kaede',
                imgStudent: student93,
                school: 'Hyakkiyako',
                schoolIcon: schoolHyakkiyakoIcon,
                attackType: 'Explosive',
            },

            {
                id: 94,
                name: 'Iroha',
                imgStudent: student94,
                school: 'Gehenna',
                schoolIcon: schoolGehennaIcon,
                attackType: 'Mystic',
            },
        ]
    },

    summerSkysWishlist: {
        eventInfo: {
            name: `Summer Sky's Wishlist`,
            value: 'summerSkysWishlist'
        },
    
        students: [
            {
                id: 57,
                name: 'S.Azusa',
                imgStudent: student57,
                school: 'Trinity',
                schoolIcon: schoolTrinityIcon,
                attackType: 'Mystic',
                limited: 'true'
            },

            {
                id: 58,
                name: 'S.Mashiro ',
                imgStudent: student58,
                school: 'Trinity',
                schoolIcon: schoolTrinityIcon,
                attackType: 'Mystic',
                limited: 'true'
            }
        ]
    },

    presidentHinasSummerVacation: {
        eventInfo: {
            name: `President Hina's Summer Vacation!`,
            value: 'presidentHinasSummerVacation'
        },
    
        students: [
            {
                id: 61,
                name: 'S. Hina',
                imgStudent: student61,
                school: 'Gehenna',
                schoolIcon: schoolGehennaIcon,
                attackType: 'Explosive',
                limited: 'true'
            },
    
            {
                id: 62,
                name: 'S. Iori ',
                imgStudent: student62,
                school: 'Gehenna',
                schoolIcon: schoolGehennaIcon,
                attackType: 'Explosive',
                limited: 'true'
            }
        ]
    },

    bunnyChaserAboard: {
        eventInfo: {
            name: 'Bunny Chaser Aboard',
            value: 'bunnyChaserAboard'
        },
    
        students: [
            {
                id: 68,
                name: 'B.Neru',
                imgStudent: student68,
                school: 'Millennium',
                schoolIcon: schoolMillenniumIcon,
                attackType: 'Explosive',
                limited: 'true'
            },

            {
                id: 69,
                name: 'B.Karin',
                imgStudent: student69,
                school: 'Millennium',
                schoolIcon: schoolMillenniumIcon,
                attackType: 'Mystic',
                limited: 'true'
            }
        ]
    },

    hatsuneMikuSpecialLive: {
        eventInfo: {
            name: `Hatsune Miku's SPECIAL LIVE in Kivotos ~Rehearsal~`,
            value: 'hatsuneMikuSpecialLive'
        },
    
        students: [
            {
                id: 73,
                name: 'Miku',
                imgStudent: student73,
                school: 'ETC',
                schoolIcon: schoolETCIcon,
                attackType: 'Explosive',
                limited: 'true'
            }
        ]
    },

    newYear: {
        eventInfo: {
            name: `New Year's Rhapsody No. 68`,
            value: 'newYear'
        },
    
        students: [
            {
                id: 79,
                name: 'N.Y.Aru',
                imgStudent: student79,
                school: 'Gehenna',
                schoolIcon: schoolGehennaIcon,
                attackType: 'Piercing',
                limited: 'true'
            },

            {
                id: 80,
                name: 'N.Y.Mutsuki',
                imgStudent: student80,
                school: 'Gehenna',
                schoolIcon: schoolGehennaIcon,
                attackType: 'Mystic',
                limited: 'true'
            }
        ]
    },

    happySchaleValentinePatrol: {
        eventInfo: {
            name: `Happy Schale ♡ Valentine patrol`,
            value: 'happySchaleValentinePatrol'
        },
    
        students: [
            {
                id: 82,
                name: 'Wakamo',
                imgStudent: student82,
                school: 'Hyakkiyako',
                schoolIcon: schoolHyakkiyakoIcon,
                attackType: 'Piercing',
                limited: 'true'
            }
        ]
    }
}

//! rare

export const importStudentsRare = [
    {
        id: 14,
        name: 'Akane',
        imgStudent: student14,
        school: 'Millennium',
        schoolIcon: schoolMillenniumIcon,
        attackType: 'Piercing',
    },

    {
        id: 15,
        name: 'Chise',
        imgStudent: student15,
        school: 'Hyakkiyako',
        schoolIcon: schoolHyakkiyakoIcon,
        attackType: 'Mystic',
    },

    {
        id: 16,
        name: 'Akari',
        imgStudent: student16,
        school: 'Gehenna',
        schoolIcon: schoolGehennaIcon,
        attackType: 'Explosive',
    },

    {
        id: 17,
        name: 'Hasumi',
        imgStudent: student17,
        school: 'Trinity',
        schoolIcon: schoolTrinityIcon,
        attackType: 'Piercing',
    },

    {
        id: 18,
        name: 'Nonomi',
        imgStudent: student18,
        school: 'Abidos',
        schoolIcon: schoolAbidosIcon,
        attackType: 'Piercing',
    },

    {
        id: 19,
        name: 'Kayoko',
        imgStudent: student19,
        school: 'Gehenna',
        schoolIcon: schoolGehennaIcon,
        attackType: 'Explosive',
    },

    {
        id: 20,
        name: 'Mutsuki',
        imgStudent: student20,
        school: 'Gehenna',
        schoolIcon: schoolGehennaIcon,
        attackType: 'Piercing',
    },

    {
        id: 21,
        name: 'Junko',
        imgStudent: student21,
        school: 'Gehenna',
        schoolIcon: schoolGehennaIcon,
        attackType: 'Piercing',
    },

    {
        id: 22,
        name: 'Serika',
        imgStudent: student22,
        school: 'Abidos',
        schoolIcon: schoolAbidosIcon,
        attackType: 'Explosive',
    },

    {
        id: 23,
        name: 'Tsubaki',
        imgStudent: student23,
        school: 'Hyakkiyako',
        schoolIcon: schoolHyakkiyakoIcon,
        attackType: 'Piercing',
    },

    {
        id: 24,
        name: 'Yuuka',
        imgStudent: student24,
        school: 'Millennium',
        schoolIcon: schoolMillenniumIcon,
        attackType: 'Explosive',
    },

    {
        id: 33,
        name: 'Airi',
        imgStudent: student33,
        school: 'Trinity',
        schoolIcon: schoolGehennaIcon,
        attackType: 'Explosive',
    },

    {
        id: 34,
        name: 'Fuuka',
        imgStudent: student34,
        school: 'Gehenna',
        schoolIcon: schoolGehennaIcon,
        attackType: 'Explosive',
    },

    {
        id: 35,
        name: 'Hanae',
        imgStudent: student35,
        school: 'Trinity',
        schoolIcon: schoolTrinityIcon,
        attackType: 'Explosive',
    },

    {
        id: 36,
        name: 'Hare',
        imgStudent: student36,
        school: 'Millennium',
        schoolIcon: schoolMillenniumIcon,
        attackType: 'Explosive',
    },

    {
        id: 37,
        name: 'Utaha',
        imgStudent: student37,
        school: 'Millennium',
        schoolIcon: schoolMillenniumIcon,
        attackType: 'Piercing',
    },

    {
        id: 38,
        name: 'Ayane',
        imgStudent: student38,
        school: 'Abidos',
        schoolIcon: schoolAbidosIcon,
        attackType: 'Piercing',
    },

    {
        id: 47,
        name: 'Shizuko',
        imgStudent: student47,
        school: 'Hyakkiyako',
        schoolIcon: schoolHyakkiyakoIcon,
        attackType: 'Mystic',
    },

    {
        id: 50,
        name: 'Momoi',
        imgStudent: student50,
        school: 'Millennium',
        schoolIcon: schoolMillenniumIcon,
        attackType: 'Piercing',
    },

    {
        id: 55,
        name: 'Hanako',
        imgStudent: student55,
        school: 'Trinity',
        schoolIcon: schoolTrinityIcon,
        attackType: 'Piercing',
    },

    {
        id: 66,
        name: 'Kirino',
        imgStudent: student66,
        school: 'Valkyrie',
        schoolIcon: schoolValkyrieIcon,
        attackType: 'Explosive',
    },

    {
        id: 72,
        name: 'Mari',
        imgStudent: student72,
        school: 'Trinity',
        schoolIcon: schoolGehennaIcon,
        attackType: 'Mystic',
    },
]

//! common

export const importStudentsCommon = [
    {
        id: 25,
        name: 'Haruka',
        imgStudent: student25,
        school: 'Gehenna',
        schoolIcon: schoolGehennaIcon,
        attackType: 'Explosive',
    },

    {
        id: 26,
        name: 'Asuna',
        imgStudent: student26,
        school: 'Millennium',
        schoolIcon: schoolMillenniumIcon,
        attackType: 'Mystic',
    },

    {
        id: 27,
        name: 'Kotori',
        imgStudent: student27,
        school: 'Millennium',
        schoolIcon: schoolMillenniumIcon,
        attackType: 'Piercing',
    },

    {
        id: 28,
        name: 'Suzumi',
        imgStudent: student28,
        school: 'Trinity',
        schoolIcon: schoolTrinityIcon,
        attackType: 'Explosive',
    },

    {
        id: 29,
        name: 'Pina',
        imgStudent: student29,
        school: 'Hyakkiyako',
        schoolIcon: schoolHyakkiyakoIcon,
        attackType: 'Piercing',
    },

    {
        id: 39,
        name: 'Chinatsu',
        imgStudent: student39,
        school: 'Gehenna',
        schoolIcon: schoolGehennaIcon,
        attackType: 'Piercing',
    },

    {
        id: 40,
        name: 'Kotama',
        imgStudent: student40,
        school: 'Millennium',
        schoolIcon: schoolMillenniumIcon,
        attackType: 'Explosive',
    },

    {
        id: 41,
        name: 'Juri',
        imgStudent: student41,
        school: 'Gehenna',
        schoolIcon: schoolGehennaIcon,
        attackType: 'Explosive',
    },

    {
        id: 42,
        name: 'Serina',
        imgStudent: student42,
        school: 'Trinity',
        schoolIcon: schoolTrinityIcon,
        attackType: 'Mystic',
    },

    {
        id: 43,
        name: 'Shimiko',
        imgStudent: student43,
        school: 'Trinity',
        schoolIcon: schoolTrinityIcon,
        attackType: 'Explosive',
    },

    {
        id: 44,
        name: 'Yoshimi',
        imgStudent: student44,
        school: 'Trinity',
        schoolIcon: schoolTrinityIcon,
        attackType: 'Piercing',
    },
]